

<div class="d-flex h-100 text-center">
    <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
        <app-navigation/>

        <div class="demo-container">
            <h1 class="display-4 text-center my-4">Demo</h1>

            <div class="demo-content">
                <div class="sticker-description">
                    <div class="tag">
                        <p>So sieht der <span class="highlight">ManualRadar</span> Sticker aus, den Sie an den von Ihnen benötigen Stellen anbringen können.</p>
                    </div>
                </div>

                <div class="qr-section">
                    <div class="qrcode sticker" style="text-align: center">
                        <img [src]="label" alt="Demo Label" class="w-50"/>
                    </div>
                </div>

                <div class="instructions-section">
                    <div class="instructions">
                        <h3>QR-Code scannen</h3>
                        <p>Bitte scannen Sie den QR-Code mit Ihrem Smartphone, um die Demo auszuprobieren.</p>
                        <p class="hint">Öffnen Sie die Kamera-App Ihres Smartphones und richten Sie sie auf den QR-Code.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
